import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { Component } from 'react';
import t from 'prop-types';
import isPlainObject from 'lodash.isplainobject';
import isString from 'lodash.isstring';
import deepEqual from 'deepequal';
import { Map, get } from 'immutable';
import { connect } from '../../../store';
import { K, bundle } from '../../../helpers';
import { corePath } from '../../../apis/http';
import { fetchSubmission, updateSubmission, fetchForm } from '../../../apis';
import { GlobalsContext } from './globals';
import { ComponentConfigContext } from '../../common/ComponentConfigContext';
import { LOCKED_BY_FIELD, LOCKED_UNTIL_FIELD, LOCK_TIME_ATTRIBUTE, LOCK_TIME_DEFAULT_VALUE, LOCK_CHECK_INTERVAL_ATTRIBUTE, LOCK_CHECK_INTERVAL_DEFAULT_VALUE, LOCK_PROMPT_TIME_ATTRIBUTE, LOCK_PROMPT_TIME_DEFAULT_VALUE, DefaultCoreFormConfig } from './defaults';
var submissionIncludes = 'values,form,form.fields,form.attributesMap,form.kapp,form.kapp.attributesMap,form.kapp.space,form.kapp.space.attributesMap';
var formIncludes = 'fields,attributesMap,kapp,kapp.attributesMap,kapp.space,kapp.space.attributesMap';

var getNumericAttributeValue = function getNumericAttributeValue(form, name) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var kapp = form ? form.kapp : null;
  var space = kapp ? kapp.space : null;
  return parseInt(form && form.attributesMap && form.attributesMap[name] && form.attributesMap[name][0] || kapp && kapp.attributesMap && kapp.attributesMap[name] && kapp.attributesMap[name][0] || space && space.attributesMap && space.attributesMap[name] && space.attributesMap[name][0], 10) || defaultValue;
};

export var isLockable = function isLockable(submission) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return submission && submission.coreState === 'Draft' && submission.values && submission.form && submission.form.fields && submission.form.fields.find(function (f) {
    return f.name === (options.lockedByField || LOCKED_BY_FIELD);
  }) && submission.form.fields.find(function (f) {
    return f.name === (options.lockedUntilField || LOCKED_UNTIL_FIELD);
  }) ? true : false;
};
export var isLocked = function isLocked(submission) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!isLockable(submission, options)) {
    return false;
  }

  var lockedUntilDate = new Date(submission.values[options.lockedUntilField || LOCKED_UNTIL_FIELD]).getTime();
  return lockedUntilDate > 0 && lockedUntilDate > new Date().getTime();
};
export var isLockedByMe = function isLockedByMe(submission) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!isLockable(submission, options) || !isLocked(submission, options)) {
    return false;
  }

  return submission.values[options.lockedByField || LOCKED_BY_FIELD] === bundle.identity();
};
export var getLockedBy = function getLockedBy(submission) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!isLockable(submission, options) || !isLocked(submission, options)) {
    return '';
  }

  return submission.values[options.lockedByField || LOCKED_BY_FIELD] || '';
};
export var getTimeLeft = function getTimeLeft(submission) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!isLockable(submission, options) || !isLocked(submission, options)) {
    return 0;
  }

  var lockedUntilDate = new Date(submission.values[options.lockedUntilField || LOCKED_UNTIL_FIELD]).getTime();
  return lockedUntilDate - new Date().getTime();
};
export var lockSubmission = function lockSubmission(_ref) {
  var id = _ref.id,
      datastore = _ref.datastore,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options;
  return fetchSubmission({
    id: id,
    datastore: !!datastore,
    include: submissionIncludes
  }).then(function (_ref2) {
    var _values;

    var submission = _ref2.submission,
        error = _ref2.error;

    if (error) {
      return {
        error: error
      };
    } else if (!isLockable(submission, options)) {
      return {
        submission: submission,
        error: {
          message: 'Submission is not lockable.'
        }
      };
    } else if (isLocked(submission, options) && !isLockedByMe(submission, options)) {
      return {
        submission: submission,
        error: {
          message: 'Submission is locked by another user.'
        }
      };
    }

    var lockTime = getNumericAttributeValue(submission.form, options.lockTimeAttribute || LOCK_TIME_ATTRIBUTE, LOCK_TIME_DEFAULT_VALUE);
    return updateSubmission({
      id: submission.id,
      include: submissionIncludes,
      values: (_values = {}, _defineProperty(_values, options.lockedByField || LOCKED_BY_FIELD, bundle.identity()), _defineProperty(_values, options.lockedUntilField || LOCKED_UNTIL_FIELD, new Date(new Date().getTime() + lockTime * 1000).toISOString()), _values)
    }).then(function (response) {
      return _objectSpread({
        submission: submission
      }, response);
    });
  });
};
export var unlockSubmission = function unlockSubmission(_ref3) {
  var id = _ref3.id,
      datastore = _ref3.datastore,
      _ref3$options = _ref3.options,
      options = _ref3$options === void 0 ? {} : _ref3$options,
      adminLockOverride = _ref3.adminLockOverride;
  return fetchSubmission({
    id: id,
    datastore: !!datastore,
    include: submissionIncludes
  }).then(function (_ref4) {
    var _values2;

    var submission = _ref4.submission,
        error = _ref4.error;

    if (error) {
      return {
        error: error
      };
    } else if (!isLockable(submission, options)) {
      return {
        submission: submission,
        error: {
          message: 'Submission is not lockable.'
        }
      };
    } else if (!isLocked(submission, options)) {
      return {
        submission: submission,
        error: {
          message: 'Submission is not locked.'
        }
      };
    } else if (!isLockedByMe(submission, options) && !adminLockOverride) {
      return {
        submission: submission,
        error: {
          message: 'Submission is locked by another user.'
        }
      };
    }

    return updateSubmission({
      id: submission.id,
      include: submissionIncludes,
      values: (_values2 = {}, _defineProperty(_values2, options.lockedByField || LOCKED_BY_FIELD, ''), _defineProperty(_values2, options.lockedUntilField || LOCKED_UNTIL_FIELD, ''), _values2)
    }).then(function (response) {
      return _objectSpread({
        submission: submission
      }, response);
    });
  });
};
export var queryString = function queryString(_ref5, _ref6) {
  var review = _ref5.review,
      values = _ref5.values;
  var reviewPages = _ref6.reviewPages,
      reviewPageIndex = _ref6.reviewPageIndex;
  var parameters = [];

  if (!!review) {
    if (typeof reviewPageIndex === 'number') {
      parameters.push("review=".concat(encodeURIComponent(reviewPages[reviewPageIndex])));
    } else if (isString(review)) {
      parameters.push("review=".concat(encodeURIComponent(review)));
    } else {
      parameters.push('review');
    }
  }

  if (isPlainObject(values)) {
    Object.keys(values).forEach(function (field) {
      parameters.push("".concat(encodeURIComponent("values[".concat(field, "]")), "=").concat(encodeURIComponent(values[field])));
    });
  }

  return parameters.join('&');
};
export var applyGuard = function applyGuard(func, context, args) {
  return typeof func === 'function' && func.apply(context, args);
};
var defaultState = {
  pending: true,
  submission: null,
  form: null,
  error: false,
  lock: null,
  reviewPageIndex: null,
  reviewPages: []
};
export var CoreFormComponent = /*#__PURE__*/function (_Component) {
  _inherits(CoreFormComponent, _Component);

  var _super = _createSuper(CoreFormComponent);

  function CoreFormComponent(props) {
    var _this;

    _classCallCheck(this, CoreFormComponent);

    _this = _super.call(this, props);

    _this.setStateSafe = function () {
      var _this2;

      return !_this._unmounted ? (_this2 = _this).setState.apply(_this2, arguments) : undefined;
    };

    _this.handleRef = function (element) {
      _this.container = element;
    };

    _this.state = _objectSpread({}, defaultState);
    return _this;
  }

  _createClass(CoreFormComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.submission && this.props.lock) {
        this.obtainLock();
      } else {
        this.fetchData();
      }
    }
  }, {
    key: "resetComponent",
    value: function resetComponent() {
      this.closeForm();
      this.setStateSafe(_objectSpread({}, defaultState));

      if (this.props.submission && this.props.lock) {
        this.obtainLock();
      } else {
        this.fetchData();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this3 = this;

      // If props changed, reset component
      if (!deepEqual(this.props, prevProps)) {
        if (prevState.lock && prevState.lock.isLockedByMe) {
          this.releaseLock({
            state: prevState,
            props: prevProps
          }).then(function () {
            _this3.resetComponent();
          });
        } else {
          this.resetComponent();
        }
      } // If pending and submission or form state has just been set, load form


      if (this.state.pending && (this.state.submission || this.state.form) && !prevState.submission && !prevState.form) {
        this.loadForm(_objectSpread(_objectSpread({}, this.props), {}, {
          // If locking is enabled and form is locked by someone else, open in review mode
          review: this.props.review || this.state.lock && !this.state.lock.isLockedByMe
        }));
      } // If pending and error state has just been set, call error callback
      else if (this.state.pending && this.state.error && !prevState.error) {
          if (this.state.error.statusCode === 401) {
            applyGuard(this.props.onUnauthorized || this.props.unauthorized);
          } else if (this.state.error.statusCode === 403) {
            applyGuard(this.props.onForbidden || this.props.forbidden);
          } else if (this.state.error.statusCode === 404) {
            applyGuard(this.props.onNotFound || this.props.onNotFound);
          } else {
            applyGuard(this.props.onError || this.props.error);
          }
        } // If locking is turned on and has been initalized


      if (this.state.lock && this.state.lock.init) {
        var lockPromptTime = getNumericAttributeValue(this.state.form, this.props.lockPromptTimeAttribute || LOCK_PROMPT_TIME_ATTRIBUTE, LOCK_PROMPT_TIME_DEFAULT_VALUE); // If I obtained the lock, start the poller

        if (this.state.lock.isLockedByMe && !this.state.lock.poller) {
          var lockCheckInterval = getNumericAttributeValue(this.state.form, this.props.lockCheckIntervalAttribute || LOCK_CHECK_INTERVAL_ATTRIBUTE, LOCK_CHECK_INTERVAL_DEFAULT_VALUE);
          this.setStateSafe({
            lock: _objectSpread(_objectSpread({}, this.state.lock), {}, {
              poller: setInterval(function () {
                _this3.pollSubmission();
              }, lockCheckInterval * 1000),
              isExpiring: false,
              lockLost: false
            })
          }); // If form is loaded and is in review mode but should be editable, close and re-load it

          this.form && !this.props.review && this.form.then(function (form) {
            if (form && form.reviewMode()) {
              _this3.closeForm();

              _this3.loadForm(_this3.props);
            }
          });
        } // If lock has been renewed, reset poller


        if (this.state.lock.isLockedByMe && this.state.lock.poller && prevState.lock && prevState.lock.isLockedByMe && this.state.lock.timeLeft > prevState.lock.timeLeft) {
          var _lockCheckInterval = getNumericAttributeValue(this.state.form, this.props.lockCheckIntervalAttribute || LOCK_CHECK_INTERVAL_ATTRIBUTE, LOCK_CHECK_INTERVAL_DEFAULT_VALUE);

          clearInterval(this.state.lock.poller);
          this.setStateSafe({
            lock: _objectSpread(_objectSpread({}, this.state.lock), {}, {
              poller: setInterval(function () {
                _this3.pollSubmission();
              }, _lockCheckInterval * 1000)
            })
          });
        } // If I lost the lock, stop the poller


        if (!this.state.lock.isLockedByMe && this.state.lock.poller) {
          clearInterval(this.state.lock.poller);
          this.setStateSafe({
            lock: _objectSpread(_objectSpread({}, this.state.lock), {}, {
              poller: null,
              isExpiring: false,
              lockLost: true
            })
          });
        } // If remaining lock time is less than lock prompt time, prompt user


        if (this.state.lock.isLockedByMe && this.state.lock.timeLeft <= lockPromptTime * 1000 && prevState.lock && prevState.lock.timeLeft > lockPromptTime * 1000) {
          this.setStateSafe({
            lock: _objectSpread(_objectSpread({}, this.state.lock), {}, {
              isExpiring: true
            })
          });
        }
      } // If submission is no longer lockable, stop poller


      if (!this.state.lock && prevState.lock && prevState.lock.poller) {
        clearInterval(prevState.lock.poller);
      } // If in review mode and page index changes, close and reload form


      if (!!this.props.review && typeof prevState.reviewPageIndex === 'number' && typeof this.state.reviewPageIndex === 'number' && this.state.reviewPageIndex !== prevState.reviewPageIndex) {
        this.closeForm();
        this.loadForm(this.props);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this4 = this;

      this._unmounted = true;

      if (this.state.lock) {
        this.releaseLock(undefined, true).then(function () {
          _this4.closeForm();
        });
      } else {
        this.closeForm();
      }
    }
  }, {
    key: "fetchData",
    value: function fetchData() {
      var _this5 = this;

      return this.props.submission ? fetchSubmission({
        id: this.props.submission,
        datastore: !!this.props.datastore,
        include: submissionIncludes,
        "public": this.props["public"]
      }).then(function (_ref7) {
        var submission = _ref7.submission,
            error = _ref7.error;

        _this5.setStateSafe({
          submission: submission,
          form: submission ? submission.form : null,
          error: error
        });
      }) : fetchForm({
        datastore: !!this.props.datastore,
        kappSlug: this.props.kapp,
        formSlug: this.props.form,
        include: formIncludes,
        "public": this.props["public"]
      }).then(function (_ref8) {
        var form = _ref8.form,
            error = _ref8.error;

        _this5.setStateSafe({
          form: form,
          error: error
        });
      });
    }
  }, {
    key: "pollSubmission",
    value: function pollSubmission() {
      var _this6 = this;

      return this.props.submission ? fetchSubmission({
        id: this.props.submission,
        datastore: !!this.props.datastore,
        include: submissionIncludes
      }).then(function (_ref9) {
        var submission = _ref9.submission,
            error = _ref9.error;

        _this6.setStateSafe({
          submission: submission,
          form: submission ? submission.form : null,
          error: error,
          lock: isLockable(submission, _this6.props) ? _objectSpread(_objectSpread({}, _this6.state.lock), {}, {
            isLocked: isLocked(submission, _this6.props),
            isLockedByMe: isLockedByMe(submission, _this6.props),
            lockedBy: getLockedBy(submission, _this6.props),
            timeLeft: getTimeLeft(submission, _this6.props)
          }) : null
        });
      }) : new Promise(function (resolve) {
        return resolve({
          error: {
            message: 'Submission Id was not provided to CoreForm.'
          }
        });
      });
    }
  }, {
    key: "obtainLock",
    value: function obtainLock() {
      var _this7 = this;

      return this.props.submission ? lockSubmission({
        id: this.props.submission,
        datastore: this.props.datastore,
        options: this.props
      }).then(function (_ref10) {
        var submission = _ref10.submission,
            error = _ref10.error;

        if (submission) {
          _this7.setStateSafe({
            submission: submission,
            form: submission ? submission.form : null,
            lock: isLockable(submission, _this7.props) ? _objectSpread(_objectSpread({}, _this7.state.lock), {}, {
              init: true,
              isExpiring: false,
              lockLost: false,
              isLocked: isLocked(submission, _this7.props),
              isLockedByMe: isLockedByMe(submission, _this7.props),
              lockedBy: getLockedBy(submission, _this7.props),
              timeLeft: getTimeLeft(submission, _this7.props),
              lockError: error
            }) : null
          });
        } else {
          _this7.setStateSafe({
            error: error
          });
        }
      }) : new Promise(function (resolve) {
        return resolve({
          error: {
            message: 'Submission Id was not provided to CoreForm.'
          }
        });
      });
    }
  }, {
    key: "releaseLock",
    value: function releaseLock() {
      var _this8 = this;

      var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref11$state = _ref11.state,
          state = _ref11$state === void 0 ? this.state : _ref11$state,
          _ref11$props = _ref11.props,
          props = _ref11$props === void 0 ? this.props : _ref11$props,
          _ref11$adminLockOverr = _ref11.adminLockOverride,
          adminLockOverride = _ref11$adminLockOverr === void 0 ? false : _ref11$adminLockOverr;

      var unmounting = arguments.length > 1 ? arguments[1] : undefined;
      return this.props.submission ? unlockSubmission({
        id: props.submission,
        options: props,
        adminLockOverride: adminLockOverride
      }).then(function (submission, error) {
        clearInterval(state.lock.poller);

        if (!unmounting) {
          _this8.setStateSafe({
            submission: submission,
            lock: isLockable(submission, props) ? _objectSpread(_objectSpread({}, state.lock), {}, {
              poller: null,
              isExpiring: false,
              isLocked: isLocked(submission, props),
              isLockedByMe: isLockedByMe(submission, props),
              lockedBy: getLockedBy(submission, props),
              timeLeft: getTimeLeft(submission, props),
              lockError: error
            }) : null
          });
        }
      }) : new Promise(function (resolve) {
        return resolve({
          error: {
            message: 'Submission Id was not provided to CoreForm.'
          }
        });
      });
    }
  }, {
    key: "previousReviewPage",
    value: function previousReviewPage() {
      this.setStateSafe({
        reviewPageIndex: Math.max(this.state.reviewPageIndex - 1, 0)
      });
    }
  }, {
    key: "nextReviewPage",
    value: function nextReviewPage() {
      this.setStateSafe({
        reviewPageIndex: Math.min(this.state.reviewPageIndex + 1, Math.max(this.state.reviewPages.length - 1, 0))
      });
    }
  }, {
    key: "goToReviewPage",
    value: function goToReviewPage(page) {
      this.setStateSafe({
        reviewPageIndex: Math.max(Math.min(page, Math.max(this.state.reviewPages.length - 1, 0)), 0)
      });
    }
  }, {
    key: "getGlobalsPromise",
    value: function getGlobalsPromise() {
      if (!this.globalsPromise) {
        if (typeof this.props.globals === 'function') {
          this.globalsPromise = this.props.globals();
        } else if (this.props.globals instanceof Promise) {
          this.globalsPromise = this.props.globals;
        } else {
          this.globalsPromise = Promise.resolve();
        }
      }

      return this.globalsPromise;
    }
  }, {
    key: "closeForm",
    value: function closeForm() {
      if (this.form) {
        this.form.then(function (form) {
          return form.close();
        });
      }
    }
  }, {
    key: "loadForm",
    value: function loadForm(props) {
      var _this9 = this;

      this.setStateSafe({
        pending: true,
        error: null
      });
      this.form = new Promise(function (resolve) {
        _this9.getGlobalsPromise().then(function () {
          K.load({
            path: "".concat(corePath(props), "?").concat(queryString(props, _this9.state)),
            container: _this9.container,
            loaded: function loaded(form) {
              resolve(form);
              var reviewState = !!props.review ? {
                reviewPageIndex: form.displayablePages().findIndex(function (currentPage) {
                  return currentPage === form.page().name();
                }),
                reviewPages: form.displayablePages()
              } : {};

              _this9.setStateSafe(_objectSpread({
                pending: false,
                error: null
              }, reviewState));

              applyGuard(props.onLoaded || props.loaded, undefined, [form]);
            },
            unauthorized: function unauthorized() {
              _this9.setStateSafe({
                pending: false,
                error: {
                  statusCode: 401
                }
              });

              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }

              applyGuard(props.onUnauthorized || props.unauthorized, undefined, args);
            },
            forbidden: function forbidden() {
              _this9.setStateSafe({
                pending: false,
                error: {
                  statusCode: 403
                }
              });

              for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
              }

              applyGuard(props.onForbidden || props.forbidden, undefined, args);
            },
            notFound: function notFound() {
              _this9.setStateSafe({
                pending: false,
                error: {
                  statusCode: 404
                }
              });

              for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                args[_key3] = arguments[_key3];
              }

              applyGuard(props.onNotFound || props.notFound, undefined, args);
            },
            error: function error() {
              _this9.setStateSafe({
                pending: false,
                error: _this9.state.error || {}
              });

              for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                args[_key4] = arguments[_key4];
              }

              applyGuard(props.onError || props.error, undefined, args);
            },
            created: props.onCreated || props.created,
            updated: props.onUpdated || props.updated,
            completed: props.onCompleted || props.completed,
            originId: props.originId,
            parentId: props.parentId,
            csrfToken: props.csrfToken
          });
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this10 = this;

      var _this$props$component = this.props.components,
          Pending = _this$props$component.Pending,
          Unauthorized = _this$props$component.Unauthorized,
          Forbidden = _this$props$component.Forbidden,
          NotFound = _this$props$component.NotFound,
          Unexpected = _this$props$component.Unexpected,
          LockMessage = _this$props$component.LockMessage,
          ReviewPaginationControl = _this$props$component.ReviewPaginationControl,
          Layout = _this$props$component.Layout;

      var _ref12 = this.state.lock || {},
          init = _ref12.init,
          poller = _ref12.poller,
          lockProps = _objectWithoutProperties(_ref12, ["init", "poller"]);

      var actions = {
        refreshSubmission: function refreshSubmission() {
          return _this10.pollSubmission();
        },
        releaseLock: this.state.lock ? function (adminLockOverride) {
          return _this10.releaseLock({
            adminLockOverride: adminLockOverride
          });
        } : undefined,
        obtainLock: this.state.lock ? function () {
          return _this10.obtainLock();
        } : undefined,
        previousPage: !!this.props.review && this.state.reviewPageIndex > 0 ? function () {
          return _this10.previousReviewPage();
        } : undefined,
        nextPage: !!this.props.review && this.state.reviewPageIndex < this.state.reviewPages.length - 1 ? function () {
          return _this10.nextReviewPage();
        } : undefined,
        goToPage: !!this.props.review ? function (page) {
          return _this10.goToReviewPage(page);
        } : undefined
      };
      var lockMessage = /*#__PURE__*/React.createElement(LockMessage, {
        lock: init ? lockProps : undefined,
        actions: actions
      });
      var reviewPaginationControl = !!this.props.review && !this.state.pending && !this.state.error && this.state.reviewPages.length > 1 ? /*#__PURE__*/React.createElement(ReviewPaginationControl, {
        pages: this.state.reviewPages,
        index: this.state.reviewPageIndex,
        actions: actions
      }) : null;
      var content = /*#__PURE__*/React.createElement("div", {
        className: "embedded-core-form"
      }, !Layout && lockMessage, /*#__PURE__*/React.createElement("div", {
        ref: this.handleRef,
        style: this.state.pending || this.state.error ? {
          display: 'none'
        } : {}
      }), this.state.pending && !this.state.error && /*#__PURE__*/React.createElement(Pending, null), this.state.error && (this.state.error.statusCode === 401 ? /*#__PURE__*/React.createElement(Unauthorized, {
        message: "You are unauthorized"
      }) : this.state.error.statusCode === 403 ? /*#__PURE__*/React.createElement(Forbidden, {
        message: "You do not have access"
      }) : this.state.error.statusCode === 404 ? /*#__PURE__*/React.createElement(NotFound, {
        message: "".concat(this.props.submission ? 'Submission' : 'Form', " not found")
      }) : /*#__PURE__*/React.createElement(Unexpected, null)), !Layout && reviewPaginationControl);
      return Layout ? /*#__PURE__*/React.createElement(Layout, {
        submission: this.state.submission,
        form: this.state.form,
        error: this.state.error,
        content: content,
        actions: actions,
        lockMessage: lockMessage,
        reviewPaginationControl: reviewPaginationControl,
        lock: init ? lockProps : undefined
      }) : content;
    }
  }]);

  return CoreFormComponent;
}(Component);

var ContextCoreFormComponent = function ContextCoreFormComponent(_ref13) {
  var components = _ref13.components,
      props = _objectWithoutProperties(_ref13, ["components"]);

  // Components passed in via deprecated props
  var deprecatedComponents = {
    Pending: props.pendingComponent,
    Unauthorized: props.unauthorizedComponent,
    Forbidden: props.forbiddenComponent,
    Unexpected: props.unexpectedErrorComponent,
    NotFound: props.notFoundComponent,
    LockMessage: props.lockMessageComponent,
    ReviewPaginationControl: props.reviewPaginationControlComponent,
    Layout: props.layoutComponent
  };
  return /*#__PURE__*/React.createElement(GlobalsContext.Consumer, null, function (globals) {
    return /*#__PURE__*/React.createElement(ComponentConfigContext.Consumer, null, function (config) {
      return /*#__PURE__*/React.createElement(CoreFormComponent, Object.assign({}, props, {
        globals: globals // Override components. Start with RKL defaults, merge in defaults
        // passed into KineticLib, then merge in deprecated components,
        // and lastly merge in components prop.
        ,
        components: DefaultCoreFormConfig.merge(Map(get(config, 'coreForm', {}))).merge(Map(deprecatedComponents).filter(Boolean)).merge(Map(components || {}).filter(Boolean)).toObject()
      }));
    });
  });
};

export var CoreForm = connect(function (state) {
  return {
    csrfToken: state.getIn(['session', 'csrfToken'])
  };
})(ContextCoreFormComponent);
CoreForm.propTypes = {
  /** Code to load prior to loading the form. */
  globals: t.oneOfType([t.func, t.instanceOf(Promise)]),

  /** Id of the submission to load. */
  submission: t.string,

  /** Slug of the form to load if submission id is not provided. */
  formSlug: t.string,

  /** Slug of the kapp which contains the form defined by formSlug. */
  kappSlug: t.string,

  /** Boolean determining if the form defined by formSlug is a datastore form. */
  datastore: t.bool,

  /** Map of field values to pass to the form. */
  values: t.object,

  /** Boolean determining if the form should be opened in review mode, or name of the page to open in review mode */
  review: t.oneOfType([t.bool, t.string]),

  /** Boolean determining if the submission should be locked when opened. */
  lock: t.bool,

  /** Callback function that will execute when the form is loaded. */
  onLoaded: t.func,
  loaded: t.func,

  /** Callback function that will execute when the form returns a 401 error. */
  onUnauthorized: t.func,
  unauthorized: t.func,

  /** Callback function that will execute when the form returns a 403 error. */
  onForbidden: t.func,
  forbidden: t.func,

  /** Callback function that will execute when the form returns a 404 error. */
  onNotFound: t.func,
  notFound: t.func,

  /** Callback function that will execute when the form returns any error. */
  onError: t.func,
  error: t.func,

  /** Callback function that will execute when a submission is created. */
  onCreated: t.func,
  created: t.func,

  /** Callback function that will execute when a submission is updated. */
  onUpdated: t.func,
  updated: t.func,

  /** Callback function that will execute when a submission is completed. */
  onCompleted: t.func,
  completed: t.func,

  /**  */
  originId: t.string,
  parentId: t.string,

  /** Component to display when the form is loading. (Deprecated: Use components prop.) */
  pendingComponent: t.func,

  /** Component to display when the form returns a 401 error. (Deprecated: Use components prop.) */
  unauthorizedComponent: t.func,

  /** Component to display when the form returns a 403 error. (Deprecated: Use components prop.) */
  forbiddenComponent: t.func,

  /** Component to display when the form returns a 404 error. (Deprecated: Use components prop.) */
  notFoundComponent: t.func,

  /** Component to display when the form returns any other error. (Deprecated: Use components prop.) */
  unexpectedErrorComponent: t.func,

  /** Component used to display the locking messages. (Deprecated: Use components prop.) */
  lockMessageComponent: t.func,

  /** Component used to display the review pagination control. (Deprecated: Use components prop.) */
  reviewPaginationControlComponent: t.func,

  /** Component used to display the entire content of the CoreForm. (Deprecated: Use components prop.) */
  layoutComponent: t.func,

  /** Map of component overrides. */
  components: t.shape({
    /** Override the loading state message. */
    Pending: t.func,

    /** Override the unauthorized error state message. */
    Unauthorized: t.func,

    /** Override the forbidden error state message. */
    Forbidden: t.func,

    /** Override the unexpected error state message. */
    Unexpected: t.func,

    /** Override the not found error state message. */
    NotFound: t.func,

    /** Override the lockMessage component shown when a form is lockable. */
    LockMessage: t.func,

    /** Override the reviewPaginationControl component shown when a form in review has multiple displayable pages. */
    ReviewPaginationControl: t.func,

    /** Override the default form layout. */
    Layout: t.func
  }),

  /** Name of field which should be used to store the locked by username. */
  lockedByField: t.string,

  /** Name of field which should be used to store the locked until value. */
  lockedUntilField: t.string,

  /** Name of attribute which stores the lock time value in seconds. */
  lockTimeAttribute: t.string,

  /** Name of attribute which stores the lock prompt time value in seconds. */
  lockPromptTimeAttribute: t.string,

  /** Name of attribute which stores the lock check interval value in seconds. */
  lockCheckIntervalAttribute: t.string
};